export default "__VITE_ASSET__CJACgsUM__"